export default class SwipeZone extends Phaser.GameObjects.Zone {
  /**
   * @param scene {GameScene}
   * @param swipeIndex {number}
   */
  constructor(scene, swipeIndex) {
    // FIXME: (sentry) Cannot read properties of null (reading 'queueDepthSort')
    super(scene, 0, 0, 0, 0);
    this.swipeIndex = swipeIndex;
    this.scene = scene;
    this.setInteractive();
    this.setOrigin(0);
    this.allowSwiping = true;
    this.swiping = false;
    this.distanceToSwipe = 0;
    this.on("pointerdown", this.startSwipe);
    this.on("pointermove", this.doSwipe);
    this.on("pointerup", this.stopSwipe);
    this.on("gameout", this.gameOut);
    this.on("pointerout", this.gameOut);
  }
  startSwipe() {
    this.swiping = true;
  }
  gameOut() {
    /* If the pointer goes out of the browser */
    const tableGameIndex = this.scene.getVisitedTableGameIndex();
    if (this.swiping)
      this.scene.cameraScrollTo(tableGameIndex * this.scene.gameWidth, tableGameIndex, tableGameIndex);
    this.swiping = false;
  }
  doSwipe(pointer) {
    if (
      this.allowSwiping &&
      this.scene.isSceneObjectsInteractive &
      this.swiping &&
      this.matchInZone(pointer)
    ) {
      /* If we have permission to swipe */
      const tableGameIndex = this.scene.getVisitedTableGameIndex();
      const deltaX = pointer.downX - pointer.x;
      const deltaY = pointer.downY - pointer.y;
      // this.cameras.main.scrollX = pointer.downX - pointer.x
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        if (tableGameIndex === this.scene.tableGames.length - 1 && deltaX > 0) {
          /* agar miz akhar bud va mikhast b miz ba'di swipe konad */
          // if( deltaX < this.displayWidth / 4) { /* ejaze swipe bish az yek chaharom safhe ra nade */
          //     this.scene.changeCameraPosition(tableGameIndex * this.scene.gameWidth + deltaX);
          // }
        } else if (tableGameIndex === 0 && deltaX < 0) {
          /* agar miz aval bud va mikhast b miz ghabli swipe konad */
          // if( Math.abs(deltaX) < this.displayWidth / 4) { /* ejaze swipe bish az yek chaharom safhe ra nade */
          //     this.scene.changeCameraPosition(tableGameIndex * this.scene.gameWidth + deltaX);
          //
          // }
        } else {
          const tablesNav = this.scene.header.tablesNav;
          const miniTable = tablesNav.tables[0];
          const activeMiniTable = tablesNav.tables[tableGameIndex];
          // const maxX = tablesNav.tables[tablesNav.tables.length - 1].miniTable.x + miniTable.miniTable.displayWidth;
          // const minX = tablesNav.tables[0].miniTable.x;
          // tablesNav.miniTableToMove.setDepth(tablesNav.miniTableToMoveDepth - 2);
          // const activeMiniTableNewX = activeMiniTable.miniTable.x + (deltaX * (miniTable.miniTable.displayWidth +miniTable.distanceBetween) / this.scene.gameWidth);
          const activeMiniTableNewX = activeMiniTable.miniTable.x + (deltaX * (miniTable.miniTable.displayWidth + miniTable.distanceBetween) / this.scene.gameWidth);
          // if(activeMiniTableNewX >= minX && activeMiniTableNewX <= maxX) 
          tablesNav.miniTableToMove.setX(activeMiniTableNewX);
          this.scene.changeCameraPosition(
            tableGameIndex * this.scene.gameWidth + deltaX
          );
        }
      }
    }
  }

  stopSwipe(pointer) {
    if (
      this.allowSwiping &&
      this.scene.isSceneObjectsInteractive && 
      this.matchInZone(pointer)
    ) {
      const tableGameIndex = this.scene.getVisitedTableGameIndex();
      this.swiping = false;
      const deltaX = pointer.downX - pointer.x;
      const deltaY = pointer.downY - pointer.y;
      const deltaTime = pointer.time - pointer.downTime;
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
       if (deltaTime > 70) {
          if (Math.abs(deltaX) >= this.distanceToSwipe && deltaX > 0) {
            /* For swipes like this '<--------------' The swipe's width is more than the distance we considered a successful swipe's distance */
            this.scene.changeVisitedTableGame(tableGameIndex + 1); /* Go to the next table */
          } else if (Math.abs(deltaX) >= this.distanceToSwipe && deltaX < 0) {
            /* For swipes like this '-------------->' The swipe's width is more than the distance we considered a successful swipe's distance */
            this.scene.changeVisitedTableGame(tableGameIndex - 1); /* Go to the previous table */
          } else if (Math.abs(deltaX) < this.distanceToSwipe) {
            /* For swipes like this '<---' and this '--->'  The swipe's width is less than the distance we considered a successful swipe's distance */
            this.scene.cameraScrollTo(
              tableGameIndex * this.scene.gameWidth, tableGameIndex, tableGameIndex
            ); /* Return to the current table */
          } else {
           this.scene.cameraScrollTo(
              tableGameIndex * this.scene.gameWidth, tableGameIndex, tableGameIndex
            ); /* Return to the current table */
          }
        } else {
          if (deltaX > 0) {
            /* For swipes like this '<-------' In a very short Time*/
            this.scene.changeVisitedTableGame(tableGameIndex + 1); /* Go to the next table */
          } else if (deltaX < 0) {
            /* For swipes like this '------->' In a very short Time*/
            this.scene.changeVisitedTableGame(
              tableGameIndex - 1
            ); /* Go to the previous table*/
          } else {
            this.scene.cameraScrollTo(
              tableGameIndex * this.scene.gameWidth, tableGameIndex, tableGameIndex
            ); /* Return to the current table */
          }
        }
      } else {
        this.scene.cameraScrollTo(
          tableGameIndex * this.scene.gameWidth, tableGameIndex, tableGameIndex
        ); /* Return to the current table */
      }
    }
  }
  matchInZone(pointer) {
    const initX = this.swipeIndex * this.scene.gameWidth;
    return (
      initX + pointer.downX >= this.x &&
      initX + pointer.downX <= this.x + this.displayWidth &&
      pointer.downY >= this.y &&
      pointer.downY <= this.y + this.displayHeight
    );
  }
  positionControls(width, height) {
    let initX = this.swipeIndex * width;
    this.setPosition(initX + width / 9, height / 10);
    this.setSize((width / 9) * 7, (height / 10) * 8);
    this.setInteractive();
    this.distanceToSwipe = this.displayWidth / 40;

    /*  Just a visual display of the drop zone */
    // let graphics2 = this.scene.add.graphics();
    // graphics2.lineStyle(2, 0xffff00);
    // graphics2.strokeRect(this.x, this.y, this.width, this.height);
  }
  remove() {
    this.destroy();
  }
}
